module.exports = __webpack_public_path__ + "img/detail-disabled.b941debc.svg";